import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FUNNELS } from "@/lib/funnels";
import { downloadGuide } from "@/lib/guides";
import { Button } from "@/components/ui/button";
import { PartyPopper, Download, MessageCircle, Home, Flame } from "lucide-react";

const WHATSAPP_NUMBER = "919601955070";

export const FunnelThankYou = ({ seg, temperature, name }) => {
  const { t } = useTranslation();
  const cfg = FUNNELS[seg];
  const msgKey = { hot: "thanksHot", warm: "thanksWarm" }[temperature] || "thanksCold";
  const wa = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t(`funnel.${seg}.whatsappMsg`))}`;
  return (
    <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} className="rounded-3xl border border-emerald-200 bg-white p-8 text-center shadow-xl sm:p-12" data-testid="funnel-thank-you">
      <span className={`mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br ${cfg.accent} text-white shadow-lg`}>
        <PartyPopper className="h-8 w-8" />
      </span>
      <h3 className="mt-6 font-heading text-3xl font-extrabold text-slate-900 sm:text-4xl" data-testid="funnel-thanks-title">{t("funnel.common.thanksTitle", { name })}</h3>
      {temperature === "hot" && (
        <p className="mx-auto mt-4 inline-flex items-center gap-1.5 rounded-full bg-rose-100 px-3 py-1 text-sm font-bold text-rose-700" data-testid="funnel-priority-badge"><Flame className="h-4 w-4" /> {t("admin.funnelHot")}</p>
      )}
      <p className="mx-auto mt-4 max-w-xl text-lg text-slate-700" data-testid="funnel-thanks-message">{t(`funnel.common.${msgKey}`)}</p>
      <p className="mt-2 text-sm text-slate-500">{t("funnel.common.thanksEmail")}</p>
      <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
        <Button onClick={() => downloadGuide(seg, name)} className={`h-12 rounded-full bg-gradient-to-r ${cfg.accent} px-7 text-base font-bold text-white`} data-testid="funnel-download-guide">
          <Download className="mr-2 h-5 w-5" /> {t("funnel.common.download")}
        </Button>
        <a href={wa} target="_blank" rel="noreferrer" className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-[#25D366] px-7 text-base font-bold text-white" data-testid="funnel-whatsapp">
          <MessageCircle className="h-5 w-5" /> {t("funnel.common.whatsapp")}
        </a>
      </div>
      <p className="mt-3 text-sm font-semibold text-slate-600">{t(`funnel.${seg}.guideName`)}</p>
      <Link to="/" className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-800" data-testid="funnel-home"><Home className="h-4 w-4" /> {t("funnel.common.home")}</Link>
    </motion.div>
  );
};
